<template>
  <v-expansion-panel class="custom_card">
    <v-expansion-panel-header>
      <div class="d-flex" style="gap: 10px;">
        <v-icon small>
          fiber_manual_record
        </v-icon>
        {{ `${service.display_name} (${service.currency.code})` }}
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row no-gutters>
          <!------------------------------------------>
          <!-- NAME ---------------------------------->
          <!------------------------------------------>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="localService.display_name"
              :label="$t('pricing_model.edit.plan.name')"
              class="rounded-lg mt-1"
              outlined
              dense
              :rules="rules.name"
              required
            />
          </v-col>
          <!------------------------------------------>
          <!-- ID ------------------------------------>
          <!------------------------------------------>
          <v-col cols="12" md="3" class="px-4">
            <v-text-field
              v-model="localService.id"
              disabled
              label="ID"
              class="rounded-lg mt-1"
              hide-details
              outlined
              dense
              required
            />
          </v-col>
          <!------------------------------------------>
          <!-- TYPE ------------------------------------>
          <!------------------------------------------>
          <v-col cols="12" md="3" class="px-4">
            <v-chip :color="getTypeObject(service.type).color">
              {{ getTypeObject(service.type).text }}
            </v-chip>
          </v-col>
          <!------------------------------------------>
          <!-- DESCRIPTION --------------------------->
          <!------------------------------------------>
          <v-col cols="12">
            <v-text-field
              v-model="localService.description"
              :label="$t('pricing_model.edit.plan.description')"
              class="rounded-lg mt-1"
              outlined
              dense
              :rules="rules.description"
              required
            />
          </v-col>
          <!------------------------------------------>
          <!-- STOCK --------------------------------->
          <!------------------------------------------>
          <v-col cols="12" md="6" class="pr-2">
            <v-text-field
              v-model="localService.stock"
              label="Stock"
              class="rounded-lg mt-1"
              outlined
              dense
              required
            />
          </v-col>
          <!------------------------------------------>
          <!-- COST ---------------------------------->
          <!------------------------------------------>
          <v-col cols="12" md="6" class="pl-2">
            <v-text-field
              v-model="localService.cost"
              label="Costo"
              class="rounded-lg mt-1"
              outlined
              dense
              :rules="rules.cost"
              required
            />
          </v-col>
          <v-col cols="12" class="d-flex justify-end mt-6" style="gap: 12px;">
            <v-btn class="rounded-lg" color="#999" @click="reset">
              <span style="color: white;">{{ $t('actions.clean') }}</span>
            </v-btn>
            <v-btn
              class="rounded-lg"
              color="#2661FF"
              @click="save"
              :loading="isUpdateLoading"
              :disabled="noChanges"
            >
              <span style="color: white;">{{ $t('actions.save') }}</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'EditService',
  props: {
    service: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data () {
    return {
      valid: true,
      isUpdateLoading: false,
      rules: {
        name: [v => !!v || this.$t('pricing_model.edit.plan.rules.name')],
        description: [
          v =>
            (!!v && v.length > 10) ||
            this.$t('pricing_model.edit.plan.rules.description')
        ],
        cost: [
          v =>
            /^\d+(\.\d+)?$/.test(v) ||
            v === null ||
            this.$t('pricing_model.edit.plan.rules.amount.number'),
          v =>
            (v && v.toString().split('.').length < 5) ||
            (v && v.toString().split('.')[1].length <= 5) ||
            this.$t('pricing_model.edit.plan.rules.amount.decimal'),
          v =>
            (v && v >= 0) || this.$t('pricing_model.edit.plan.rules.amount.min')
        ]
      },
      localService: null
    }
  },
  created () {
    this.init()
  },
  computed: {
    noChanges () {
      const servicesKeys = Object.keys(this.service)
      return servicesKeys.every(key => {
        const serviceValue = this.service[key]
        const localValue = this.localService[key]
        return this.isEqual(serviceValue, localValue)
      })
    }
  },
  methods: {
    ...mapActions({
      updateService: 'pricingModels/updateService'
    }),
    init () {
      this.service.id = parseInt(this.service.id)
      this.localService = {
        ...this.service,
        id: parseInt(this.service.id)
      }
    },
    getTypeObject (type) {
      const mappedTypes = {
        1: {
          text: 'Automation',
          color: '#FFC107'
        },
        2: {
          text: 'Whatsapp',
          color: '#4CAF50'
        },
        3: {
          text: 'API CALL',
          color: '#FF5'
        },
        4: {
          text: 'SMS',
          color: '#FF5722'
        },
        5: {
          text: 'Query',
          color: '#03A9F4'
        },
        6: {
          text: 'Usuarios adicionales',
          color: '#9C27B0'
        },
        7: {
          text: 'Agregar Registros',
          color: '#1E88E5'
        },
        8: {
          text: 'Gateway fee',
          color: '#bcd'
        }
      }

      return mappedTypes[type] || { text: 'Unknown', color: '#999' }
    },
    isEqual (a, b) {
      if (a === b) return true
      if (typeof a !== 'object' || typeof b !== 'object') return false
      const keysA = Object.keys(a)
      const keysB = Object.keys(b)
      if (keysA.length !== keysB.length) return false
      for (const key of keysA) {
        if (!keysB.includes(key) || !this.isEqual(a[key], b[key])) return false
      }
      return true
    },
    validate () {
      return this.$refs.form.validate()
    },
    reset () {
      this.localService = {
        ...this.service,
        id: parseInt(this.service.id)
      }
    },
    async save () {
      if (this.validate()) {
        try {
          this.isUpdateLoading = true

          // Update in database
          const updatedService = await this.updateService(this.localService)

          // Update in list
          this.$emit('update-service', updatedService)
        } catch (error) {
        } finally {
          this.isUpdateLoading = false
        }
      }
    }
  }
}
</script>

<style lang="scss">
.custom_card {
  border-radius: 12px !important;
  border: 1px solid #d0d3db !important;
}
.text_color {
  color: #344054 !important;
}
</style>
